import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import TableRowAction from 'components/common/TableRowAction';
import { weFeedBackData, weGiftEidData } from 'data/weraise-data/donar-data';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const DonorFeedback = () => {
  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref.',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => <Link to="#">{rowData.row.original.ref}</Link>
    },
    {
      accessor: 'date',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'feed',
      Header: 'Feed',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <p className="text-truncate mb-0" style={{ maxWidth: '400px' }}>
          {rowData.row.original.feed}
        </p>
      )
    },
    {
      accessor: 'priority',
      Header: 'Priority',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <p className={rowData.row.original.color}>
          {rowData.row.original.priority}
        </p>
      )
    },
    {
      accessor: 'id',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];
  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="mt-2 fw-bold">Feedback</h4>}
          light={false}
          titleTag="div"
          menuClassName="align-items-center"
          endEl={
            <IconButton icon="plus" transform="shrink-3">
              <span className="d-none d-md-inline-block ms-2">
                Add Donation
              </span>
            </IconButton>
          }
        />
      </Card>
      <Card className="mb-3">
        <Card.Header className="p-4 pb-0">
          <Card.Title className="fs-2 fw-bold">Feedback & Ratings</Card.Title>
        </Card.Header>
        <Card.Body className="p-4">
          {weFeedBackData.map(item => (
            <Flex key={item.id} justifyContent={'between'}>
              <p className="text-800">{item.label}</p>
              <p className="text-800">
                <FontAwesomeIcon
                  icon={'circle'}
                  className={`me-2 ${item.iconColor}`}
                />
                {item.value}/{item.baseValue}
              </p>
            </Flex>
          ))}
        </Card.Body>
      </Card>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weGiftEidData}
            columns={columns}
            title="Clint Feedback"
            showSearchInput
            searchInputPlaceHolder="Search"
            addNew
            perPage={10}
          />
        </Col>
      </Row>
    </>
  );
};

export default DonorFeedback;
